import {BrowserRouter, Route, Routes} from "react-router-dom";
import DialogProvider from "../providers/DialogProvider";
import SnackbarProvider from "../providers/SnackbarProvider";
import {getRoutesWithResolvers} from "../utils/menu";
import PageScaffold from "./PageScaffold";
import Requirements from "./Requirements";

export default function AppRoutes() {
    const routes = getRoutesWithResolvers();

    return (
        <BrowserRouter>
            <DialogProvider>
                <SnackbarProvider>
                    <Requirements>
                        <Routes>
                            {routes.map((m) => {
                                if (m.requireAuthentication) {
                                    return (
                                        <Route
                                            key={m.url}
                                            element={
                                                <PageScaffold
                                                    showMenu={m.showMenu}
                                                />
                                            }
                                        >
                                            <Route
                                                path={m.url}
                                                element={m.componentResolver}
                                            />
                                        </Route>
                                    );
                                } else {
                                    return (
                                        <Route
                                            key={m.url}
                                            path={m.url}
                                            element={m.componentResolver}
                                        />
                                    );
                                }
                            })}
                        </Routes>
                    </Requirements>
                </SnackbarProvider>
            </DialogProvider>
        </BrowserRouter>
    );
}
